






















import Vue from 'vue'
export default Vue.extend({
  name: 'FileUpload',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ''
    }
  },
  methods: {
    trigger () {
      const fileInputEle = this.$refs.fileInput as HTMLInputElement
      fileInputEle.click()
    },
    handleChange (event: Event) {
      this.$emit('change', event)
      const eventTarget = event.target as EventTarget & HTMLInputElement
      eventTarget.value = ''
    },
    handleDragOver (event: Event) {
      event.preventDefault()
      this.$emit('onDragOver', event)
    },
    handleDragLeave (event: Event) {
      event.preventDefault()
      this.$emit('onDragLeave', event)
    },
    handleDrop (event: DragEvent) {
      event.preventDefault()
      if (event.dataTransfer && event.dataTransfer.files) {
        this.$emit('change', event)
      }
    }
  }
})
